<script src="warning.component.ts"></script>

<div class="warning-modal">
  <div>
    <h2>
      <md-icon>warning</md-icon>
      Warning : {{warningTitle}}
    </h2>
  </div>
    <md-dialog-content>      
    <p [innerHtml]="warningContent"></p>
    </md-dialog-content>
  </div>  
  <md-dialog-actions class="actions">
    <button md-raised-button (click)="dialogRef.close('no')">
      <md-icon>cancel</md-icon>Cancel
    </button>
    <button md-raised-button (click)="dialogRef.close('yes')" color="primary">
      <md-icon>check</md-icon>Proceed
    </button>
  </md-dialog-actions>



// WEBPACK FOOTER //
// ./src/app/modals/warning-modal/warning-modal.component.html